export const REMOVE_FROM_CATEGORY = 'REMOVE_FROM_CATEGORY'
export const ADD_TO_CATEGORY = 'ADD_TO_CATEGORY'